export enum EQUIPMENT_TYPE_LABEL {
  ONDULEUR = 'Onduleur',
  METEO = 'Meteo',
  COMPTEUR = 'Compteur',
  CAPTEUR = 'Capteur',
  INVERTER = 'inverter',
  HYGROMETER = 'hygrometer',
  SISENSOR = 'sisensor',
  TEMPSENSOR = 'tempsensor',
  PYRANOMETER = 'pyranometer',
  METER = 'meter',
}

export enum SYSTEM_LABEL_INFO {
  CENTRALE = '(Centrale)',
  PRISME = '(Prisme)',
  EXTERNAL_METEO = '(METEO EXTERNE)',
}
